import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import Preloader from "../../components/Preloader";
import NetworkError from "../../components/NetworkError";
import { textes } from "../../constants/textes";
import { config } from "../../constants/config";
import Pagination from "../../components/Pagination";
import Select from "react-select";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CardText, Cash, Clock, Person, PhoneFill, TextParagraph, } from "react-bootstrap-icons";
import Search from "../Search";
import InPayement from "../inpayement";
import Vpnr from "./vpnr";
import Vpn from "./vpn";

export default function Vpns() {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [inpayment, setinpayment] = useState(false);
    const [addstate, setAddstate] = useState(false);

    const [fetching, setFetching] = useState(false);

    const [elementsList, setElementsList] = useState([]);
    const [nbpage, setNbpage] = useState(1);
    const [nbelement, setNbelement] = useState(0);
    const [page, setPage] = useState(0);

    const [isSearch, setIsSearch] = useState(false);
    const [chaine, setChaine] = useState('');

    const [encash, setencash] = useState(false);
    const [username, setusername] = useState("");
    const [password, setpassword] = useState("");
    const [dureeval, setdureeval] = useState("");
    const [duree, setduree] = useState("");
    const [desc, setdesc] = useState("");
    const [prix, setprix] = useState("");
    const [datedeb, setdatedeb] = useState(new Date().toISOString());
    const [abonnement, setabonnement] = useState('');
    const [abonnementsList, setabonnementsList] = useState([]);
    const [numtel, setnumtel] = useState('');
    const [noms, setnoms] = useState('');
    const [revendeur, setrevendeur] = useState('');
    const [revendeursList, setrevendeursList] = useState([]);
    const [picture, setPicture] = useState('');
    const [pictureprev, setPictureprev] = useState('/assets/imgs/no-image.png');


    const [codetransaction, setcodetransaction] = useState('');
    const [idop, setidop] = useState('');
    const [valtoken, setvaltoken] = useState('');
    let timerID = null;
    let intervId = null;
    const [textloader, settextloader] = useState('Payement en cours: En attente de confirmation.');

    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    // const showWarningMessage = (msg) => {
    //     toast.warning(msg, {
    //         position: toast.POSITION.BOTTOM_CENTER,
    //         autoClose: 5000,
    //         hideProgressBar: false,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //         theme: "colored",
    //     });
    // }

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const getElementsList = async (p) => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)
        let clientarraydata = [];

        if (user?.isFullAction || user.isAdminAction) {
            await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/vpns?page=${p + 1}`, requestOptions).then((response) => {
                if (response?.status === 200) {
                    response.json().then(async (data) => {
                        // console.log("resonse jsondecode", data?.body?.data);
                        if (data?.head) {
                            let clientarray = [];

                            clientarray = data?.body?.data;

                            await clientarray.forEach(element => {
                                clientarraydata.push({ urltype: "vpns", ...element });
                            });

                            setElementsList(clientarraydata);

                            setNbpage(data?.body?.pages);
                            setNbelement(data?.body?.length);
                            if (!user.isFullAction && !user.isAdminAction) {
                                setnoms(user.nom);
                            }
                            // setLoading(false);
                        } else {
                            if (data?.body?.data?.msg === "expiredsession") {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                setError(true);
                                setLoading(false);
                            }
                        }
                    });
                } else if (response?.status === 401) {
                    logoutUser();
                    navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                } else {
                    setError(true);
                    setLoading(false);
                }

            }).catch((err) => {
                // console.log("error", err);
                setError(true);
                setLoading(false);
            });

            await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/vpnaccounts?page=${p + 1}`, requestOptions).then((response) => {
                if (response?.status === 200) {
                    response.json().then(async (data) => {
                        // console.log("resonse jsondecode", data?.body?.data);
                        if (data?.head) {
                            let clientarray = []
                            clientarray = data?.body?.data;

                            await clientarray.forEach(element => {
                                clientarraydata.push({ urltype: "comptevpns", ...element });
                            });

                            setElementsList(clientarraydata);

                            // setElementsList(clientarray);
                            // setNbpage(data?.body?.pages);
                            // setNbelement(data?.body?.length);
                            // if (!user.isFullAction && !user.isAdminAction) {
                            //     setnoms(user.nom);
                            // }
                            setLoading(false);
                        } else {
                            if (data?.body?.data?.msg === "expiredsession") {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                setError(true);
                                setLoading(false);
                            }
                        }
                    });
                } else if (response?.status === 401) {
                    logoutUser();
                    navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                } else {
                    setError(true);
                    setLoading(false);
                }

            }).catch((err) => {
                // console.log("error", err);
                setError(true);
                setLoading(false);
            });
        } else {
            await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/vpns?page=${p + 1}&coderevendeur=${user?.codeutilisateur}`, requestOptions).then((response) => {
                if (response?.status === 200) {
                    response.json().then(async (data) => {
                        // console.log("resonse jsondecode", data?.body?.data);
                        if (data?.head) {
                            let clientarray = []
                            clientarray = data?.body?.data;

                            await clientarray.forEach(element => {
                                clientarraydata.push({ urltype: "vpns", ...element });
                            });

                            setElementsList(clientarraydata);

                            // setElementsList(clientarray);
                            setNbpage(data?.body?.pages);
                            setNbelement(data?.body?.length);
                            if (!user.isFullAction && !user.isAdminAction) {
                                setnoms(user.nom);
                            }
                            // setLoading(false);
                        } else {
                            if (data?.body?.data?.msg === "expiredsession") {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                setError(true);
                                setLoading(false);
                            }
                        }
                    });
                } else if (response?.status === 401) {
                    logoutUser();
                    navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                } else {
                    setError(true);
                    setLoading(false);
                }

            }).catch((err) => {
                // console.log("error", err);
                setError(true);
                setLoading(false);
            });

            await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/vpnaccounts?page=${p + 1}&coderevendeur=${user?.codeutilisateur}`, requestOptions).then((response) => {
                if (response?.status === 200) {
                    response.json().then(async (data) => {
                        // console.log("resonse jsondecode", data?.body?.data);
                        if (data?.head) {
                            let clientarray = [];

                            clientarray = data?.body?.data;

                            await clientarray.forEach(element => {
                                clientarraydata.push({ urltype: "comptevpns", ...element });
                            });

                            setElementsList(clientarraydata);

                            // setElementsList(clientarray);
                            // setNbpage(data?.body?.pages);
                            // setNbelement(data?.body?.length);
                            // if (!user.isFullAction && !user.isAdminAction) {
                            //     setnoms(user.nom);
                            // }
                            setLoading(false);
                        } else {
                            if (data?.body?.data?.msg === "expiredsession") {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                setError(true);
                                setLoading(false);
                            }
                        }
                    });
                } else if (response?.status === 401) {
                    logoutUser();
                    navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                } else {
                    setError(true);
                    setLoading(false);
                }

            }).catch((err) => {
                // console.log("error", err);
                setError(true);
                setLoading(false);
            });
        }

    }

    const autoSearchElement = async (c) => {
        setPage(0);
        if ((c && !isSearch) || (c && isSearch)) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
            myHeaders.append("token", config.app.PUBLICKEY);
            myHeaders.append("apikey", user.token);
            myHeaders.append("cpte", user.code);
            myHeaders.append("prof", user.profil);
            myHeaders.append("conn", user.espace);


            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                // body: urlencoded,
                redirect: 'follow'
            };

            // console.log("data send", urlencoded)

            await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/vpns?crit=${c}`, requestOptions).then((response) => {
                if (response?.status === 200) {
                    response.json().then(async (data) => {
                        if (data?.head) {
                            // console.log("resonse jsondecode", data);
                            let clientarray = [];
                            clientarray = data?.body?.data;

                            setElementsList(clientarray);
                            setNbpage(data?.body?.pages);
                            setNbelement(data?.body?.length);
                            // setLoading(false);
                        } else {
                            if (data?.body?.data?.msg === "expiredsession") {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                setError(true);
                            }
                            // setLoading(false);
                        }
                    });
                } else if (response?.status === 401) {
                    logoutUser();
                    navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                } else {
                    setError(true);
                    // setLoading(false);
                }

            }).catch((err) => {
                // console.log("error", err);
                setError(true);
                // setLoading(false);
            });
        } else if (c !== "" && isSearch) {
            setIsSearch(false);
            getElementsList(page);
        } else {
            setIsSearch(false);
            getElementsList(page);
        }
    }

    const getRevendeursList = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/users?type=revendeur`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {

                            // if (element.abrevtypeutilisateur === "RVD") {
                            //     clientarraydata.push({ label: element.nom + " " + element.prenom, value: element.code });
                            // }
                            clientarraydata.push({ label: element.nom + " " + element.prenom, value: element.codeutilisateur });

                        });

                        setrevendeursList(clientarraydata);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("server error", err);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("statut error", err);
            }

        }).catch((err) => {
            console.log("error get reventeurs list", err);
            // setError(true);
            // setLoading(false);
        });
    }

    const getAbonnementVPNList = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/subscriptions`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            if (element?.abrevtabonnement === "AVPNS") {
                                clientarraydata.push({ label: element.lib, value: element.code, pduree: element.duree, pprix: element?.prix, pack: element.prof });
                            }
                        });


                        setabonnementsList(clientarraydata);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("server error", err);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("statut error", err);
            }

        }).catch((err) => {
            // console.log("error get client list", err);
            // setError(true);
            // setLoading(false);
        });
    }

    function generatePassword() {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var password = '';
        for (let i = 0; i < 24; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            password += characters[randomIndex];
        }
        return password;
    }


    const setPassword = () => {
        const newPass = generatePassword();
        setpassword(newPass);
        // console.log("new password: ", newPass);
    }

    const handleencash = () => {
        setencash(!encash);
    };

    // console.log("vpn elements: ", elementsList);
    // console.log("current date time: ", new Date().toISOString());

    // comportements
    useEffect(() => {
        getElementsList(page);
        getRevendeursList();
        getAbonnementVPNList();
        setPassword();
    }, []);

    // useEffect(() => {
    //     const stimeout = setTimeout(() => {
    //         autoSearchElement(chaine);
    //     }, 1000);

    //     return () => clearTimeout(stimeout);
    // }, [chaine]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var urlencoded = new URLSearchParams();
        if (username) urlencoded.append("username", username);
        if (password) urlencoded.append("mdp", password);
        urlencoded.append("datedeb", datedeb);
        if (abonnement) urlencoded.append("duree", dureeval + " days");
        // if (picture) urlencoded.append("img", pictureprev);
        urlencoded.append("codecompterevendeur", (user?.isFullAction || user?.isAdminAction) ? revendeur["value"] : user?.codeutilisateur);
        if (abonnement) urlencoded.append("codeabonnement", abonnement["value"]);
        urlencoded.append("defaut", false);
        urlencoded.append("edit", true);
        urlencoded.append("etatdef", "Publié");

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: urlencoded,
            redirect: "follow",
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/vpns`, requestOptions).then((response) => {
            if (response?.status === 200 || response?.status === 201) {
                response.json().then(async (data) => {
                    // console.log("resonse ajout droit", data);
                    if (!data?.head) {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setFetching(false);
                            showErrorMessage(data?.body?.data?.msg);
                        }
                    } else {
                        showSuccesMessage(textes.fr.comptevpnaddedlabel);
                        setAddstate(false);
                        setinpayment(false);
                        getElementsList(page);
                        setusername("");
                        setpassword("");
                        setdesc("");
                        setduree("");
                        setprix("");
                        setdatedeb(new Date().toISOString());
                        setabonnement("");
                        setPictureprev('/assets/imgs/no-image.png');
                        setrevendeur("");
                        setPicture("");
                        setnumtel("");
                        setnoms("");
                        setFetching(false);
                    }

                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("resonse ", response);
                // setError(true);
                showErrorMessage(textes.fr.serviceunavaillable);
                setFetching(false);
            }
        }).catch((err) => {
            // console.log("error", err);
            // setError(true);
            showErrorMessage(textes.fr.serviceunavaillable);
            setFetching(false);
        });
    };

    const handlePay = async (e) => {
        e.preventDefault();

        setFetching(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var urlencoded = new URLSearchParams();
        urlencoded.append("codeabonnement", abonnement["value"]);
        urlencoded.append("pack", abonnement["pack"]);
        urlencoded.append("montant", abonnement["pprix"]);
        urlencoded.append("nom", noms);
        urlencoded.append("numtel", "+237" + numtel);
        urlencoded.append("descr", "Achat de l'abonnement VPN Yconnekt " + abonnement["pduree"] + " à " + abonnement["pprix"] + " XAF");
        urlencoded.append("defaut", false);
        urlencoded.append("edit", true);
        urlencoded.append("etatdef", "Initié");

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: urlencoded,
            redirect: "follow",
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions`, requestOptions).then((response) => {
            if (response?.status === 200 || response?.status === 201) {
                response.json().then(async (data) => {
                    // console.log("resonse ajout droit", data);
                    if (!data?.head) {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setFetching(false);
                            showErrorMessage(data?.body?.data?.msg);
                        }
                    } else {
                        setinpayment(true);
                        setcodetransaction(data?.body?.data?.creertransaction);
                        setidop(data?.body?.data?.idop);

                        let codetr = data?.body?.data?.creertransaction;
                        let idopin = data?.body?.data?.idop;

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

                        var urlencoded = new URLSearchParams();
                        urlencoded.append("username", config.campay.campayuser);
                        urlencoded.append("password", config.campay.campaypass);

                        var requestOptions = {
                            method: 'POST',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        fetch(`${config.campay.urlToCampay}/api/token/`, requestOptions).then(response => response.text()).then(result => {
                            console.log("Retour etape 1", JSON.stringify(result));
                            setvaltoken(JSON.parse(result).token);
                            let valtokent = JSON.parse(result).token;

                            var myHeaders2 = new Headers();
                            myHeaders2.append("Content-Type", "application/x-www-form-urlencoded");
                            myHeaders2.append("Authorization", "Token " + valtokent);

                            var urlencoded2 = new URLSearchParams();
                            urlencoded2.append("amount", prix);
                            urlencoded2.append("from", "237" + numtel);
                            urlencoded2.append("description", desc);
                            urlencoded2.append("external_reference", idopin);

                            console.log(`urlencode2: ${urlencoded2}`)
                            var requestOptions2 = {
                                method: 'POST',
                                headers: myHeaders2,
                                body: urlencoded2,
                                redirect: 'follow'
                            };

                            fetch(`${config.campay.urlToCampay}/api/collect/`, requestOptions2).then(response => response.text()).then(result => {
                                console.log("Retour etape 2", result);
                                let camref = JSON.parse(result).reference;
                                let operator = JSON.parse(result).operator;

                                var myHeaders3 = new Headers();
                                myHeaders3.append("Content-Type", "application/x-www-form-urlencoded");
                                myHeaders3.append("token", config.app.PUBLICKEY);
                                myHeaders3.append("apikey", user.token);
                                myHeaders3.append("cpte", user.code);
                                myHeaders3.append("prof", user.profil);
                                myHeaders3.append("conn", user.espace);

                                var urlencoded3 = new URLSearchParams();
                                // urlencoded3.append("code", codetransaction);
                                urlencoded3.append("refint", camref);
                                urlencoded3.append("operateur", operator);
                                urlencoded3.append("etat", 2);
                                urlencoded3.append("etatdef", "En cours");

                                var requestOptions3 = {
                                    method: 'PATCH',
                                    headers: myHeaders3,
                                    body: urlencoded3,
                                    redirect: 'follow'
                                };

                                fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions/${codetr}`, requestOptions3).then((response) => {
                                    console.log("Retour etape 3", response);
                                    if (response?.status === 205) {
                                        // textloader.setAttribute("data-text", "Payement en attente de confirmation...");
                                        startInterval(codetr, valtokent);
                                    } else if (response?.status === 200) {
                                        response.json().then(async (data) => {
                                            console.log("erreur: ", data?.body?.data?.msg);
                                            showErrorMessage(data?.body?.data?.msg);
                                            setinpayment(false);
                                        });
                                    } else {
                                        console.log(`Service indisponible`);
                                        showErrorMessage("Service indisponible! veuillez reessayer plutard.");
                                        setinpayment(false);
                                    }


                                    // fetch(`${urlMetiier}/transactions`, requestOptions3)
                                    //     .then(response => response.text())
                                    //     .then(result => {
                                    //         console.log("Retour etape 3", result);
                                    //         let body = JSON.parse(result);

                                    //         if (body?.data.head) {

                                    //             // textloader.innerText = "Payement en attente de confirmation...";
                                    //             textloader.setAttribute("data-text", "Payement en attente de confirmation...");
                                    //             startInterval(codetransaction, valtoken);


                                    //         } else {
                                    //             console.log(`Problème lors du traitement de votre transaction`);
                                    //             showErrorMessage("Problème lors du traitement du payement! veuillez reessayer plutard.")
                                    //         }


                                    //     })
                                    //     .catch(error => {
                                    //         console.log('error', error);
                                    //         showErrorMessage("Problème lors du traitement du payement! veuillez reessayer plutard.")
                                    //     });


                                }).catch(error => {
                                    console.log('error', error);
                                    showErrorMessage("Problème lors du traitement du payement! veuillez reessayer plutard.")
                                    setinpayment(false);
                                });
                            })
                        });
                    }

                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("resonse ", response);
                // setError(true);
                showErrorMessage(textes.fr.serviceunavaillable);
                setFetching(false);
            }
        }).catch((err) => {
            // console.log("error", err);
            // setError(true);
            showErrorMessage(textes.fr.serviceunavaillable);
            setFetching(false);
        });
    };

    const startInterval = async (code, token) => {
        console.log("first intervId: ", intervId);
        intervId = setInterval(async () => {

            try {
                settextloader("Vérification du payement...");
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                myHeaders.append("token", config.app.PUBLICKEY);
                myHeaders.append("apikey", user.token);
                myHeaders.append("cpte", user.code);
                myHeaders.append("prof", user.profil);
                myHeaders.append("conn", user.espace);

                var requestOptions = {
                    method: 'GET',
                    headers: myHeaders,
                    // body: urlencoded,
                    redirect: 'follow'
                };

                // console.log("data send", urlencoded)

                await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions/${code}`, requestOptions).then((response) => {
                    if (response?.status === 200) {
                        response.json().then(async (data) => {
                            // console.log("resonse jsondecode", data?.body?.data);
                            if (data?.head) {
                                let body = data?.body?.data[0];
                                if (body?.etat === 3) {
                                    console.log(`transaction non confirmé`);
                                    // stop interval
                                    stopInterval();
                                    showErrorMessage("Echec de l'achat de l'abonnement");
                                } else if (body?.etat === 4) {
                                    console.log('paymement effectué');
                                    stopInterval();
                                    // handleSubmit();
                                    // showSuccessMessage("Achat de l'abonnement réussi! Vous allez recevoir un SMS de confirmation contenant vos identifiants de connexion.");
                                } else if (body?.etat === 2) {
                                    let refint = body?.refint;

                                    var myHeaders2 = new Headers();
                                    myHeaders2.append("Content-Type", "application/x-www-form-urlencoded");
                                    myHeaders2.append("Authorization", "Token " + token);

                                    var requestOptions2 = {
                                        method: 'GET',
                                        headers: myHeaders2,
                                        redirect: 'follow'
                                    };

                                    fetch(`${config.campay.urlToCampay}/api/transaction/${refint}/`, requestOptions2)
                                        .then(response => response.text())
                                        .then(result => {
                                            console.log("Boucle 2 campay", result)
                                            let body = JSON.parse(result);

                                            if (body.status === "SUCCESSFUL") {
                                                stopInterval();
                                                lastUpdate(code, body.code, body.operator_reference, 4, "Réussie");
                                            } else if (body.status === "FAILED") {
                                                stopInterval();
                                                lastUpdate(code, body.code, body.operator_reference, 3, "Echec");
                                            }

                                        })
                                        .catch(error => {
                                            console.log('error', error);
                                            stopInterval();
                                        });

                                }

                            } else {
                                setError(true);
                                setLoading(false);
                            }
                        });
                    } else {
                        console.log('Erreur de confirmation');
                        stopInterval();
                    }

                }).catch((err) => {
                    console.log('error', err);
                    stopInterval();
                });

            } catch (error) {
                console.log(`try cash error: ${error}`)
            }
            console.log("second intervId: ", intervId);

        }, 10000);
        // setintervId(pintervId);
    }

    function stopInterval() {
        // timerzone.setAttribute("style", "display: none;");
        clearInterval(intervId);
        clearInterval(timerID);
        intervId = null;
        timerID = null;
        // countDownTime = defaultValue;
    }

    const lastUpdate = async (code, codeint, refop, etat, etatdef) => {
        settextloader("Achèvement du payement...");
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var urlencoded = new URLSearchParams();
        // urlencoded.append("code", code);
        urlencoded.append("codeint", codeint);
        urlencoded.append("refop", refop);
        urlencoded.append("etat", etat);
        urlencoded.append("etatdef", etatdef);

        if (etat === 4) urlencoded.append("coderevendeur", (user?.isFullAction || user?.isAdminAction) ? revendeur["value"] : user?.codeutilisateur);
        if (etat === 4) urlencoded.append("type", "vpn");
        if (username && etat === 4) urlencoded.append("userlocal", username);
        if (password && etat === 4) urlencoded.append("mdplocal", password);
        // if (redirection) urlencoded.append("redirect", redirection);
        if (etat === 4) urlencoded.append("datedeb", datedeb);
        if (abonnement && etat === 4) urlencoded.append("duree", dureeval + " years");
        if (abonnement && etat === 4) urlencoded.append("codeabonnement", abonnement["value"]);
        // if (picture) urlencoded.append("img", pictureprev);

        var requestOptions3 = {
            method: 'PATCH',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions/${code}`, requestOptions3).then((response) => {
            console.log("Last update result", response);
            if (response?.status === 205) {
                stopInterval();
                if (etat === 4) {
                    console.log(`transaction terminé réussi`);
                    showSuccesMessage(textes.fr.comptevpnaddedlabel);
                    setAddstate(false);
                    setinpayment(false);
                    getElementsList(page);
                    setusername("");
                    setdesc("");
                    setpassword("");
                    setduree("");
                    setprix("");
                    setdatedeb(new Date().toISOString());
                    setabonnement("");
                    setPictureprev('/assets/imgs/no-image.png');
                    setrevendeur("");
                    setPicture("");
                    setnumtel("");
                    setnoms("");
                    setFetching(false);
                    // handleSubmit();
                    // showSuccessMessage("Achat de l'abonnement réussi! Vous allez recevoir un SMS de confirmation contenant vos identifiants de connexion.");
                }

                if (etat === 3) {
                    console.log(`transaction terminé echec`);
                    setinpayment(false);
                    showErrorMessage("Echec de l'achat de l'abonnement");
                }

                // loader.setAttribute("style", "display: none;");
            } else if (response?.status === 200) {
                response.json().then(async (data) => {
                    stopInterval();
                    console.log(`Echec de mise à jour de la ref op`);
                    // loader.setAttribute("style", "display: none;")
                    console.log("erreur: ", data?.body?.data?.msg);
                    showErrorMessage("erreur: " + data?.body?.data?.msg);
                    setinpayment(false);

                });
            } else {
                setinpayment(false);
                console.log(`Service indisponible`);
                showErrorMessage("Service indisponible! veuillez reessayer plutard.");
            }

        }).catch(error => {
            stopInterval();
            console.log('error', error);
            setinpayment(false);
            // loader.setAttribute("style", "display: none;");
        });
    }


    // affichages
    return (
        <div className="row">
            <div className="col-md-12">
                {loading && <Preloader />}
                {!loading && error && <NetworkError />}
                {!loading && !error && inpayment && <InPayement text={textloader} />}
                {!loading && !error && !inpayment && (
                    <div
                        className="col-md-12"
                        style={{
                            paddingTop: 8,
                            borderTop: "1px solid #ddd",
                            borderRadius: 8,
                        }}
                    >
                        <div className="row">
                            {/* <div className="col-md-12 mb-3">
                                <Search
                                    chaine={chaine}
                                    setChaine={setChaine}
                                    // search={searchEmployee}
                                    placeholder="Rechercher..."
                                />
                            </div> */}
                            <div className="col-md-12 mb-3">
                                {addstate && <div className="card w-100 border-info mb-3">
                                    <div className="card-body alert-info">
                                        <h5 className="card-title text-info"><i className="fa fa-exclamation-circle mr-2"></i> Information</h5>
                                        <p className="card-text">La création d'un <strong>compte VPN</strong> passe par l'achat d'un <strong>abonnement</strong>. Il sera question après avoir remplit les informations du compte VPN, de sélectionner <strong>l'abonnement qui vous convient</strong> et de fournir le numéro <strong>ORANGE MONEY / MOBILE MONEY</strong> à utiliser pour le paiement de l'abonnemnt sélectionné et ainsi <strong>valider</strong> la création de votre compte VPN.</p>
                                    </div>
                                </div>}
                                <div className="card shadow mb-4">
                                    <div className="card-header py-3">
                                        {!addstate && (
                                            <button
                                                data-toggle="tooltip"
                                                title={textes.fr.newcomptevpnlabel}
                                                onClick={() => {setAddstate(true); setPassword();}}
                                                data-placement="left"
                                                className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                            >
                                                <i className="fa fa-plus mr-1"></i>{" "}
                                                <span>{textes.fr.newcomptevpnlabel}</span>
                                            </button>
                                        )}
                                        <h6 className="m-0 ">
                                            {addstate
                                                ? textes.fr.comptevpninfoslabel
                                                : textes.fr.listcomptevpnlabel}
                                        </h6>
                                    </div>
                                    {!addstate && (
                                        <div className="card-body">
                                            <div className="table-responsive mb-3">
                                                <table className="mb-0 table table-bordered">
                                                    <thead className="bg-primary">
                                                        <tr className="bg-primary text-white">
                                                            <th className="text-center">#</th>
                                                            {(user?.isFullAction || user?.isAdminAction) && <th>Revendeur</th>}
                                                            <th>Nom d'utilisateur</th>
                                                            {/* <th>Prix</th> */}
                                                            <th>Durée</th>
                                                            <th>Date début</th>
                                                            <th>Datefin</th>
                                                            <th>{textes.fr.statelabel}</th>
                                                            <th>{textes.fr.addeddatelabel}</th>
                                                            <th className="text-center">
                                                                {textes.fr.actionlabel}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {elementsList.length === 0 && (
                                                            <tr style={{ borderStyle: "none" }}>
                                                                <th colSpan={(user?.isFullAction || user?.isAdminAction) ? 9 : 8} className="text-center">
                                                                    {textes.fr.nocomptevpnfound}
                                                                </th>
                                                            </tr>
                                                        )}
                                                        {elementsList.length > 0 &&
                                                            elementsList?.map((item, index) => (
                                                                (user?.isFullAction || user?.isAdminAction) ?
                                                                    <Vpnr
                                                                        vpn={item}
                                                                        position={config.app.limit * page + index}
                                                                        key={index}
                                                                    /> :

                                                                    <Vpn
                                                                        vpn={item}
                                                                        position={(config.app.limit * page) + index}
                                                                        key={index}
                                                                    />
                                                            ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <Pagination
                                                nbpage={nbpage}
                                                getList={getElementsList}
                                                page={page}
                                                setPage={setPage}
                                            />
                                        </div>
                                    )}
                                    {addstate && (
                                        <div className="card-body">
                                            <form style={{ width: "100%" }} onSubmit={!encash ? handlePay : handleSubmit}>
                                                <div className="row">
                                                    <div className="col-md-12 mb-3">
                                                        <div className="row">
                                                            {(user?.isFullAction || user?.isAdminAction) && <div className="col-md-12 mb-3">
                                                                <div className="form-check">
                                                                    <input type="checkbox" id="encash"
                                                                        className="form-check-input"
                                                                        checked={encash}
                                                                        onChange={handleencash}
                                                                    />
                                                                    <label htmlFor="encash" className="mb-1 form-check-label">Paiement en Cash?</label>
                                                                </div>
                                                            </div>}
                                                            {(user?.isFullAction || user?.isAdminAction) && <div className="col-md-12 mb-3">
                                                                <label htmlFor="revendeur" className="mb-1">
                                                                    {textes.fr.revendeurlabel}
                                                                </label>
                                                                <Select
                                                                    id="revendeur"
                                                                    name="revendeur"
                                                                    placeholder={textes.fr.selectlabel}
                                                                    options={revendeursList}
                                                                    value={revendeur}
                                                                    onChange={(selected) => {
                                                                        setrevendeur(selected);
                                                                        if (selected !== null) {
                                                                            setnoms(selected["label"]);
                                                                        } else {
                                                                            setnoms("");
                                                                        }

                                                                    }}
                                                                    isClearable
                                                                />
                                                            </div>}
                                                            <div className="col-md-12 mb-3">
                                                                <label htmlFor="abonnement" className="mb-1">
                                                                    {textes.fr.abonnementlabel}
                                                                </label>
                                                                <Select
                                                                    id="abonnement"
                                                                    name="abonnement"
                                                                    placeholder={textes.fr.selectlabel}
                                                                    options={abonnementsList}
                                                                    value={abonnement}
                                                                    onChange={(selected) => {
                                                                        setabonnement(selected);
                                                                        if (selected) {
                                                                            let dr = selected["pduree"].split(" ");
                                                                            setprix(selected["pprix"]);
                                                                            setduree(selected["pduree"]);
                                                                            setdureeval(dr[0]);
                                                                        } else {
                                                                            setprix("");
                                                                            setduree("");
                                                                            setdureeval("");
                                                                        }

                                                                    }}
                                                                    isClearable
                                                                />
                                                            </div>
                                                            <div className="col-md-12 mb-3">
                                                                <label htmlFor="username" className="mb-1">
                                                                    Nom d'utilisateur
                                                                </label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span
                                                                        className="input-group-text"
                                                                        id="username"
                                                                    >
                                                                        <TextParagraph />
                                                                    </span>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder={textes.fr.entervaluelabel}
                                                                        value={username}
                                                                        onChange={(e) =>
                                                                            setusername(e.target.value)
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-12 mb-3">
                                                                <label htmlFor="password" className="mb-1">
                                                                    Mot de passe
                                                                </label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span
                                                                        className="input-group-text"
                                                                        id="password"
                                                                    >
                                                                        <CardText />
                                                                    </span>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder={textes.fr.entervaluelabel}
                                                                        value={password}
                                                                        onChange={(e) =>
                                                                            setpassword(e.target.value)
                                                                        }
                                                                        disabled
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label htmlFor="prix" className="mb-1">
                                                                    Prix
                                                                </label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span
                                                                        className="input-group-text"
                                                                        id="prix"
                                                                    >
                                                                        <Cash />
                                                                    </span>
                                                                    <input
                                                                        type="number"
                                                                        min={0}
                                                                        className="form-control"
                                                                        placeholder={textes.fr.entervaluelabel}
                                                                        value={prix}
                                                                        onChange={(e) => { setprix(e.target.value) }}
                                                                        disabled
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 mb-5">
                                                                <label htmlFor="duree" className="mb-1">
                                                                    {textes.fr.durelabel}
                                                                </label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span
                                                                        className="input-group-text"
                                                                        id="duree"
                                                                    >
                                                                        <Clock />
                                                                    </span>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Entrez la durée"
                                                                        value={duree}
                                                                        onChange={(e) =>
                                                                            setduree(e.target.value)
                                                                        }
                                                                        disabled
                                                                    />
                                                                </div>
                                                            </div>
                                                            {!encash && <div className="col-md-12 mt-3 mb-2">
                                                                <h5 className="text-primary">Information de paiement</h5>
                                                            </div>}
                                                            {!encash && <div className="col-md-6 mb-3">
                                                                <label htmlFor="numtel" className="mb-1">Numéro de téléphone OM / MOMO</label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span className="input-group-text" id="numtel"><PhoneFill /></span>
                                                                    <input
                                                                        type="tel"
                                                                        className="form-control"
                                                                        placeholder="Entrez le numéro de téléphone"
                                                                        value={numtel}
                                                                        onChange={(e) =>
                                                                            setnumtel(e.target.value)
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>}
                                                            {!encash && <div className="col-md-6 mb-3">
                                                                <label htmlFor="noms" className="mb-1">Noms</label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span className="input-group-text" id="noms"><Person /></span>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Entrez le nom"
                                                                        value={noms}
                                                                        onChange={(e) =>
                                                                            setnoms(e.target.value)
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mt-2">
                                                        {!encash && <button
                                                            type="submit"
                                                            title={textes.fr.newcomptevpnlabel}
                                                            className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                            disabled={
                                                                abonnement["value"] && username && duree && prix && numtel && noms
                                                                    ? false
                                                                    : true
                                                            }
                                                        >
                                                            <i className="fa fa-check mr-2"></i>
                                                            <span>Valider</span>{" "}
                                                            {fetching && (
                                                                <Spinner
                                                                    as="span"
                                                                    animation="border"
                                                                    size="sm"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                />
                                                            )}
                                                        </button>}
                                                        {encash && <button
                                                            type="submit"
                                                            title={textes.fr.newcomptevpnlabel}
                                                            className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                            disabled={
                                                                abonnement["value"] && username && duree && prix
                                                                    ? false
                                                                    : true
                                                            }
                                                        >
                                                            <i className="fa fa-check mr-2"></i>
                                                            <span>Valider</span>{" "}
                                                            {fetching && (
                                                                <Spinner
                                                                    as="span"
                                                                    animation="border"
                                                                    size="sm"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                />
                                                            )}
                                                        </button>}
                                                        <button
                                                            onClick={() => {
                                                                setAddstate(false);
                                                                getElementsList(page);
                                                                setusername("");
                                                                setdesc("");
                                                                setpassword("");
                                                                setduree("");
                                                                setprix("");
                                                                setdatedeb(new Date().toISOString());
                                                                setabonnement("");
                                                                setPictureprev('/assets/imgs/no-image.png');
                                                                setrevendeur("");
                                                                setPicture("");
                                                                setnumtel("");
                                                                setnoms("");
                                                            }}
                                                            title={textes.fr.cancel}
                                                            className="btn-shadow ml-3 btn btn-danger btn-sm float-right"
                                                        >
                                                            <i className="fa fa-reply mr-1"></i>{" "}
                                                            <span>{textes.fr.cancel}</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
